(function($){
$(document).ready(function(){

	var $html = $('html'),
		$body = $('body');


	var totalPoints = 0;
	var $result;

	//add transition delays
	$('.quiz__result').each(function() {
		var $this = $(this);
		var delay = 0;

		$this.find('p').each(function() {
			var $col = $(this);
			$col.css('transition-delay', ( delay+=0.5 ) + 's');
		});
		$this.find('.delaymoretime').each(function() {
			var $col = $(this);
			$col.css('transition-delay', ( delay+=3.5 ) + 's');
		});
	});


	$('.quiz__carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		draggable: false,
		touchMove: false,
		swipe: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	$( ".quiz__answer" ).on('click', function() {
		var $this = $(this);
		$this.addClass('is-active');
		$this.siblings().removeClass('is-active');
		$this.parent().find('.quiz__btn-next').removeClass('disabled');
	});


	$( ".quiz__btn-next" ).on('click', function() {
		var $this = $(this);
		if( $this.hasClass('disabled') ) {
			return;
		}
		$('.quiz__carousel').slick('slickNext');
		if($(window).width() < 570) {
			$(window).scrollTop(0); //Add auto scroll to top on quiz
		}
	});

	$( ".quiz__btn-next--final" ).on('click', function() {
		$('.quiz__carousel').addClass('d-none');

		//calculate total
		$('.quiz__answer.is-active').each(function() {
			var $this = $(this);
			totalPoints += parseInt( $this.data('punctaj'), 10);
		});

		//get result
		$('.quiz__result').each(function() {
			var $this = $(this),
				punctajMinim = parseInt( $this.data('punctaj-minim'), 10),
				punctajMaxim = parseInt( $this.data('punctaj-maxim'), 10);

			if( totalPoints >= punctajMinim && totalPoints <= punctajMaxim ) {
				$result = $this;
			}
		});

		$result.find('.quiz__score span').text( totalPoints );
		$result.addClass('is-active');
		//var $collectData = $('.quiz__result a.collect-data').attr('href');
		//var $collectDataScore = $('.quiz__result.is-active .quiz__score span').text();
		//var $collectDataProduct = $('.quiz__result.is-active .quiz__product-name a').text();
		//$('.quiz__result.is-active a.collect-data').attr('href', $collectData + '?p=' + $collectDataProduct + '?sc=' + $collectDataScore);


	});

});

})(jQuery);
